import styled from 'styled-components';

import UpResetButton from '../up-reset-button';

interface WrapperStyleProps {
  errorMessage?: React.ReactNode;
}

export const Wrapper = styled.div<WrapperStyleProps>`
  margin-top: ${(props) => (props.errorMessage ? '0px' : '37px')};
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.reverse {
    flex-direction: row-reverse;
  }
`;

export const Error = styled.div`
  margin: 8.5px 0 8.5px 20px;
`;

export const ResetButton = styled(UpResetButton)`
  margin-left: auto;

  ${Wrapper}.reverse & {
    margin-left: 0;
  }
`;
